export enum WidgetType {
  Menu = 'menu',
  Ordering = 'ordering',
}

export const isOrderingWidgetType = (widgetType: unknown): widgetType is WidgetType.Ordering =>
  widgetType === WidgetType.Ordering;

export enum ItemsToShow {
  All = 'all',
  Highlighted = 'highlighted',
  Discount = 'discount',
  Manual = 'manual',
  SingleSection = 'single-section',
}
